import ResultTable from "../../Table/ResultTable";
import {MessageCodes} from "../MessageCodes";
import numWords from "num-words";
import ToUpper from "../ToUpper";
import EmptyLine from "../../EmptyLine";
import ResultHeader from "../../Table/ResultHeader";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultCellHighlight from "../../Table/ResultCellHighlight";
import ResultText from "../ResultText";
import ComparisonCSName from "../../ComparisonCSName";

const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.TDSRC001.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in the downstream reach lengths at the following {row.data.length} cross sections:
                        <EmptyLine />
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell rowSpan={3} style={{textAlign: 'left', verticalAlign: 'bottom'}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell colSpan={6}>Downstream Reach Length (ft)</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell colSpan={3}>{globalVariables?.sel_plan_title || 'Base'}</ResultHeaderCell>
                                <ResultHeaderCell colSpan={3}>{globalVariables?.tar_plan_title || 'Comparison'}</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'right'}}>LOB</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Channel</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>ROB</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>LOB</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>Channel</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right'}}>ROB</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row.data.map(r => {
                                    return (
                                        <ResultRow>
                                            <ResultBodyCell style={{textAlign: 'left', width: 125}}><ComparisonCSName csName={r.cross_section} /></ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right', width: 65}}>{r.base?.lob}</ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right', width: 65}}>{r.base?.channel}</ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right', width: 65}}>{r.base?.rob}</ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right', width: 65}}>{ResultCellHighlight(r.base?.lob, r.compare?.lob)}</ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right', width: 65}}>{ResultCellHighlight(r.base?.channel, r.compare?.channel)}</ResultBodyCell>
                                            <ResultBodyCell style={{textAlign: 'right', width: 65}}>{ResultCellHighlight(r.base?.rob, r.compare?.rob)}</ResultBodyCell>
                                        </ResultRow>
                                    )
                                })
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

export const C20 = {
    RenderDescription,
}